import { type AccountForChildEligibilityDetails, Operation } from '@generated-types';
import { alreadyHasAccount, hasExistingProcessInCurrentBank } from '@utils/child-status-utils';
import type { ChildWithExistingProcess } from '@/types/child-types';

const getAllowedOperations = ({ currentBankCreateShareSavingsAccountEligibility }: AccountForChildEligibilityDetails) =>
    currentBankCreateShareSavingsAccountEligibility.allowedOperations;

export const canStartNewProcess = (eligibilityDetails: AccountForChildEligibilityDetails) =>
    getAllowedOperations(eligibilityDetails).includes(Operation.START_NEW_PROCESS);

export const canSeeProcessStatus = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingProcess =>
    hasExistingProcessInCurrentBank(childEligibility) &&
    getAllowedOperations(childEligibility).includes(Operation.SEE_PROCESS_STATUS);

export const canSeeCompleteProcessStatus = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingProcess =>
    hasExistingProcessInCurrentBank(childEligibility) &&
    getAllowedOperations(childEligibility).includes(Operation.SEE_COMPLETED_PROCESS_STATUS);

export const canCompleteKYCForm = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingProcess =>
    hasExistingProcessInCurrentBank(childEligibility) &&
    getAllowedOperations(childEligibility).includes(Operation.GO_TO_KYC);

export const canGiveConsent = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingProcess =>
    hasExistingProcessInCurrentBank(childEligibility) &&
    getAllowedOperations(childEligibility).includes(Operation.GIVE_CONSENT);

export const actionAvailable = (childEligibility: AccountForChildEligibilityDetails) =>
    canStartNewProcess(childEligibility) ||
    canSeeProcessStatus(childEligibility) ||
    canGiveConsent(childEligibility) ||
    canCompleteKYCForm(childEligibility) ||
    canSeeCompleteProcessStatus(childEligibility) ||
    alreadyHasAccount(childEligibility);
